import type { ComponentProps, ReactNode } from 'react'
import { Icon } from '@ui/icon'

type Props = {
  title?: ReactNode
  icon: ComponentProps<typeof Icon>['name']
  onSubmit: () => void
}

export const IconButton = ({ title, icon, onSubmit }: Props) => {
  return (
    <div
      onClick={onSubmit}
      className="bg-gray-100 border-2 border-gray-150 rounded-lg aspect-square flex items-center justify-center cursor-pointer hover:bg-gray-200 hover:border-gray-200 transition"
    >
      <div className="flex items-center justify-center flex-col gap-3">
        <Icon name={icon} size={72} />
        <p className="text-2xl font-bold">{title}</p>
      </div>
    </div>
  )
}
